module.exports = function() {
  return new Worker(__webpack_public_path__ + "d3b930f30ced54c60e3f.worker.js");
};